import { withStyles } from '@material-ui/core';
import Label from './common/Label';
import Detail from './common/Detail';

const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  labelContainer: {
    marginBottom: 8
  },
  qaItem: {
    marginBottom: 8
  }
});

const getAnswerDisplayValue = (answerValue) => {
  const isEmpty = answerValue == null || (typeof answerValue === 'string' && !answerValue.trim());
  return isEmpty ? 'NA' : answerValue;
};

const ExceptionQADetails = ({ classes, qaList }) => {
  return (
    <div className={classes.container}>
      <div className={classes.labelContainer}>
        <Label labelText="EXCEPTION Q&A" />
      </div>
      {qaList
        .filter((qa) => qa?.questionLabel)
        .map((qa, index) => (
          <div key={qa?.questionId ?? index} className={classes.qaItem}>
            <Detail
              label={qa.questionLabel}
              value={getAnswerDisplayValue(qa?.answerValue)}
              isFullWidth
            />
          </div>
        ))}
    </div>
  );
};

export default withStyles(styles)(ExceptionQADetails);
